import CircularProgress from '@mui/material/CircularProgress';
import type {ButtonHTMLAttributes, ReactNode} from 'react';

import css from './Button.module.css';

export type ButtonVariant =
	| 'primary'
	| 'secondary'
	| 'tertiary'
	| 'outlineSecondary'
	| 'ghostPrimary'
	| 'error';

export type ButtonSize = 'extraSmall' | 'small' | 'medium' | 'large';

interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'> {
	variantType?: ButtonVariant;
	size?: ButtonSize;
	fullWidth?: boolean;
	loading?: boolean;
	startIcon?: ReactNode;
	endIcon?: ReactNode;
	className?: string;
}

/**
 * Кнопка кита ОТВЕТО. Native button, а не MuiButton: вся палитра состояний лежит
 * в переменных --btn-*, и переопределять поверх MUI пришлось бы больше, чем написать.
 */
export function Button({
	variantType = 'primary',
	size = 'medium',
	fullWidth,
	loading,
	disabled,
	startIcon,
	endIcon,
	children,
	className,
	type = 'button',
	...rest
}: ButtonProps) {
	const classes = [css.root, css[variantType], css[size], fullWidth ? css.fullWidth : '', className]
		.filter(Boolean)
		.join(' ');

	return (
		<button {...rest} type={type} className={classes} disabled={disabled || loading}>
			<span className={css.loadingWrap}>
				{/*
				 * Содержимое — свой flex-контейнер, а не голый span.
				 *
				 * gap у .root к паре «иконка + текст» не применяется: между ними лежит
				 * эта обёртка, и для кнопки они не отдельные дети, а один. Пока класса
				 * здесь не было, иконка стояла вплотную к слову и выравнивалась
				 * по базовой линии текста — то есть визуально съезжала вниз.
				 */}
				<span className={`${css.content} ${loading ? css.loadingLabel : ''}`}>
					{startIcon}
					{children}
					{endIcon}
				</span>
				{loading ? (
					<span className={css.spinner}>
						<CircularProgress size={20} color="inherit" />
					</span>
				) : null}
			</span>
		</button>
	);
}
